import React, { useContext } from 'react'

import BackButton from 'components/Button/BackButton'
import PrimaryButton from 'components/Button/PrimaryButton'
import Description from 'components/Description/VerifaiDescription'
import { Icon } from 'components/Image/Icon'
import { CautionImage } from 'components/Image/Image.style'
import Body from 'components/Screen/Body/VerifaiBody'
import Footer from 'components/Screen/Footer/VerifaiFooter'
import Header from 'components/Screen/Header/VerifaiHeader'
import Heading from 'components/Screen/Heading/Heading'
import Screen from 'components/Screen/Screen'
import { VerifaiMessage } from 'components/Text/VerifaiIntl'
import { ConfigContext } from 'context/ConfigContextProvider'
import { Router } from 'typings/context'

interface CautionProps {
  router: Router
}

function Caution(props: CautionProps) {
  const { router } = props

  const config = useContext(ConfigContext)

  return (
    <Screen>
      <Heading>
        <Header messageKey="caution_title" />
      </Heading>

      <Body>
        <Description>
          <VerifaiMessage
            id="caution_description"
            values={{ name: config.cautionInfo.name, reason: config.cautionInfo.reason }}
          />
        </Description>

        <CautionImage>
          <Icon id="cautionImage" />
        </CautionImage>
      </Body>

      <Footer>
        <BackButton />
        <PrimaryButton
          messageId="WA1_button_primary"
          onClick={() => router.next()}
          dataTestId="greeting-continue-btn"
        />
      </Footer>
    </Screen>
  )
}

export default Caution
